import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';

import Layout from 'components/Layout';
import Meta from 'components/Meta';
import Banner from 'components/Banner';
import SectionContact from 'components/SectionContact';

import CheckIcon from 'images/icons/check.svg';

import { SolutionsDetail } from 'styles/solutions-detail';
import SolutionSteps from '../../components/SolutionSteps/SolutionSteps';

const SolutionCSDPage = ({ path }) => (
  <>
    <Meta
      title="Custom Application Development | Enterprise Web Development | ATC Digital Business Solutions"
      description="Custom applications developed by us are tailor-made that fit the demands of different businesses by creating agile, scalable, and innovative web applications."
    />
    <Layout background="#ffffff" path={path}>
      <SolutionsDetail>
        <Banner
          backgroundSrc="solutions/custom-application-development-banner.jpg"
          title="Enterprise Application Development. Delight your customers."
          className="darken-image"
          style={{ paddingBottom: 100 }}
        >
          <p
            className="white-txt"
            style={{
              fontSize: 18,
              letterSpacing: 0.2,
              lineHeight: '28px',
            }}
          >
            Serve your customers by transforming your solutions into
            user-friendly, user-focused applications.
          </p>
          <Link
            to="/contact-us/"
            className="pink-btn"
            style={{ minWidth: 180 }}
          >
            <span>Learn how to get started</span>
          </Link>
          <a
            href="#brief"
            onClick={(e) => {
              e.preventDefault();
              if (typeof window !== 'undefined')
                window.scrollb.scrollIntoView(document.getElementById('brief'));
            }}
            className="white-btn brief-btn"
          >
            <span>What to expect</span>
          </a>
        </Banner>

        <section className="principle-main">
          <div className="container">
            <div className="row">
              <div className="col-md-12 col-lg-8">
                <h2 className="medium-heading">Evolve to Stay Competitive</h2>
                <p className="white-txt">
                  Maintain your competitive edge in an increasingly fast moving
                  and difficult digital environment time by actively staying at
                  the forefront of technology. We help you solve seemingly
                  complex problems in surprisingly simple ways. ATC specializes
                  in giving shape and form to great software product ideas from
                  across industries by deploying the best people for the job and
                  using the latest methodologies in software development.
                </p>
              </div>
            </div>
          </div>
        </section>

        <SolutionSteps
          id="enterpriseApplicationDevelopment"
          flyText="Application Development"
          flyBoxImage="solutions/custom-dev-box.jpg"
        />

        <section id="brief">
          <div className="grey-bg center">
            <div className="container">
              <div className="featured-partner-block">
                <h2 className="medium-heading black-txt">
                  Software Development for Enterprise: Leveraging Data
                </h2>
                <p>
                  Design thinking helps you come up with innovative, real-world
                  solutions. To bring your vision to life, you need a
                  time-tested product development engine that can take charge
                  and seamlessly handle design, development, quality assurance,
                  and post-delivery maintenance. ATC leverages Rapid Application
                  Development, Continuous Integration, and Continuous Delivery
                  to dramatically cut down time to market for SaaS products
                  while enabling faster upgrades based on user feedback.
                </p>
                <Link
                  to="/contact-us/"
                  className="pink-btn d-none d-md-inline-block"
                >
                  <span>Talk to an Expert</span>
                </Link>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div className="why-partner-main">
            <div className="container">
              <div className="row">
                <div className="col-md-4">
                  <h2 className="big-heading">
                    Custom
                    <br />
                    Software
                    <span className="pink">.</span>
                  </h2>
                </div>
                <div className="col-md-8">
                  <div className="row">
                    <div className="col-md-6 col-6">
                      <div className="why-partner-single">
                        <span className="why-partner-icon">
                          <CheckIcon />
                        </span>
                        <h3>Scale</h3>
                        <p>Built with Lean-Agile and DevOps for rapid scale.</p>
                      </div>
                    </div>
                    <div className="col-md-6 col-6">
                      <div className="why-partner-single">
                        <span className="why-partner-icon">
                          <CheckIcon />
                        </span>
                        <h3>Optimization</h3>
                        <p>Optimize resources and cost with rightshoring.</p>
                      </div>
                    </div>
                    <div className="col-md-6 col-6">
                      <div className="why-partner-single">
                        <span className="why-partner-icon">
                          <CheckIcon />
                        </span>
                        <h3>Delivery</h3>
                        <p>Delivery for quick time-to-market.</p>
                      </div>
                    </div>
                    <div className="col-md-6 col-6">
                      <div className="why-partner-single">
                        <span className="why-partner-icon">
                          <CheckIcon />
                        </span>
                        <h3>Testing</h3>
                        <p>Built-in testing and software QA.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <SectionContact />
      </SolutionsDetail>
    </Layout>
  </>
);

SolutionCSDPage.propTypes = {
  path: PropTypes.string.isRequired,
};

export default SolutionCSDPage;
